/* @ngInject */
const excelStyles = () => {
  const self = {}

  self.default = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    borderStyle: 'thin',
    borderColor: '888888',
    border: {
      top: false,
      bottom: true,
      left: true,
      right: true,
    },
    fill: {
      type: 'solid',
      color: 'ffffff',
    },
    fontSize: 8,
  }

  self.bodyCell = (stripped = false) => {
    return {
      horizontalAlignment: 'center',
      verticalAlignment: 'center',
      borderStyle: 'thin',
      borderColor: '888888',
      border: {
        top: false,
        bottom: true,
        left: true,
        right: true,
      },
      fill: {
        type: 'solid',
        color: stripped ? 'dddddd' : 'eeeeee',
      },
      fontSize: 8,
    }
  }

  self.bodyCellRed = (stripped = false) => {
    return {
      horizontalAlignment: 'center',
      verticalAlignment: 'center',
      borderStyle: 'thin',
      borderColor: '888888',
      border: {
        top: false,
        bottom: true,
        left: true,
        right: true,
      },
      fill: {
        type: 'solid',
        color: stripped ? 'dddddd' : 'eeeeee',
      },
      fontSize: 8,
      fontColor: 'red',
    }
  }

  self.borderedCell = (color = 'FFFFFF') => {
    return {
      horizontalAlignment: 'center',
      verticalAlignment: 'center',
      borderStyle: 'medium',
      borderColor: '000000',
      border: {
        top: true,
        bottom: true,
        left: true,
        right: true,
      },
      fill: {
        type: 'solid',
        color: color,
      },
      bold: true,
    }
  }

  self.titleRange = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    bold: true,
    fontSize: 20,
    borderStyle: 'medium',
    borderColor: '000000',
  }

  self.titleImage = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    bold: true,
    fontSize: 20,
    fill: {
      type: 'solid',
      color: 'D9D9D9',
    },
    borderStyle: 'medium',
    borderColor: '000000',
  }

  self.headerCell = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    borderStyle: 'medium',
    borderColor: '000000',
    border: {
      top: true,
      bottom: true,
      left: true,
      right: true,
    },
    bold: true,
    italic: true,
  }

  self.invoiceHeader = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    borderStyle: 'thin',
    borderColor: '000000',
    bold: true,
    fill: {
      type: 'solid',
      color: 'FABF8F',
    },
  }

  self.invoiceHeaderGrey = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    bold: true,
    fill: {
      type: 'solid',
      color: 'D9D9D9',
    },
  }

  self.invoiceHeaderOrange = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    bold: true,
    fill: {
      type: 'solid',
      color: 'FABF8F',
    },
  }

  self.invoiceCell = {
    fill: {
      type: 'solid',
      color: 'FFFFFF',
    },
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    borderStyle: 'hair',
    borderColor: '000000',
    border: {
      top: false,
      bottom: true,
      left: true,
      right: true,
    },
  }

  self.wrapText = {
    fill: {
      type: 'solid',
      color: 'FFFFFF',
    },
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    borderStyle: 'hair',
    borderColor: '000000',
    border: {
      top: false,
      bottom: true,
      left: false,
      right: true,
    },
    wrapText: true,
  }

  self.invoiceTotal = {
    fill: {
      type: 'solid',
      color: 'FABF8F',
    },
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    borderStyle: 'medium',
    borderColor: '000000',
    border: {
      top: true,
      bottom: true,
      left: true,
      right: true,
    },
    bold: true,
    fontSize: 24,
  }

  self.underline = {
    bold: true,
    verticalAlignment: 'center',
    borderStyle: 'medium',
    borderColor: '000000',
    border: {
      top: false,
      bottom: true,
      left: false,
      right: false,
    },
  }

  self.blCell = (stripped = false) => {
    return {
      horizontalAlignment: 'center',
      verticalAlignment: 'center',
      borderStyle: 'thin',
      borderColor: '888888',
      border: {
        top: false,
        bottom: true,
        left: true,
        right: true,
      },
      fill: {
        type: 'solid',
        color: stripped ? 'dddddd' : 'eeeeee',
      },
      fontSize: 11,
      fontColor: '000000',
    }
  }

  self.blCellBold = (stripped = false) => {
    return {
      horizontalAlignment: 'center',
      verticalAlignment: 'center',
      borderStyle: 'thin',
      borderColor: '888888',
      border: {
        top: false,
        bottom: true,
        left: true,
        right: true,
      },
      fill: {
        type: 'solid',
        color: stripped ? 'dddddd' : 'eeeeee',
      },
      fontSize: 11,
      bold: true,
      fontColor: 'FF0000',
    }
  }

  self.blEndArray = () => {
    return {
      horizontalAlignment: 'center',
      verticalAlignment: 'center',
      borderStyle: 'thick',
      borderColor: '888888',
      border: {
        top: true,
        bottom: true,
        left: true,
        right: true,
      },
      fill: {
        type: 'solid',
        color: 'D9D9D9',
      },
      fontSize: 11,
      bold: true,
    }
  }

  self.blFooter = () => {
    return {
      horizontalAlignment: 'center',
      verticalAlignment: 'center',
      borderStyle: 'medium',
      borderColor: '888888',
      border: {
        top: true,
        bottom: true,
        left: true,
        right: true,
      },
      fill: {
        type: 'solid',
        color: 'FFFFFF',
      },
      fontSize: 12,
      bold: true,
    }
  }

  self.noStyle = {}

  return self
}
export default excelStyles



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/excel.style.js